import { Theme } from '@mui/material/styles'

const useStyles = {
  toggleButtonGroup: (theme: Theme) => ({
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      gap: '3px',
      padding: 0,
    },
  }),
  toggleButton: (theme: Theme) => ({
    border: '1px solid #D3D4D8',
    borderRadius: theme.shape.largeBorderRadius,
    backgroundColor: theme.palette.background.paper,
    padding: '6px 8px',
    color: theme.palette.text.primary,
    textTransform: 'none',
    flexDirection: 'column',
    width: '100px',

    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.hover,
      border: '1px solid transparent',
      color: theme.palette.text.disabled,
      pointerEvents: 'auto',
    },
    '&.MuiToggleButtonGroup-grouped:not(:last-of-type), &.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
      margin: 0,
      border: '1px solid #D3D4D8',
      borderRadius: theme.shape.largeBorderRadius,
    },
    '&.Mui-selected, &.MuiToggleButtonGroup-grouped:not(:last-of-type).Mui-selected, &.MuiToggleButtonGroup-grouped:not(:first-of-type).Mui-selected, &.MuiToggleButtonGroup-grouped.Mui-selected+.MuiToggleButtonGroup-grouped.Mui-selected':
      {
        border: `1px solid ${theme.palette.action.hover}`,
        backgroundColor: 'rgba(0, 120, 236, 0.08)',
        color: theme.palette.text.primary,
        '&:hover': {
          backgroundColor: 'rgba(0, 120, 236, 0.08)',
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.action.hover,
          border: '1px solid transparent',
          color: theme.palette.text.disabled,
        },
      },
    '&:hover': {
      backgroundColor: 'inherit',
    },
  }),
}

export default useStyles
